import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "./appApiCallHook";

export function useCommonApi() {
  const callApi = useApiCall();

  const enhanceText = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.ENHANCE_TEXT, data, onSuccess, onError, true);
  };

  const generateJobDescriptionSkills = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GENERATE_JOB_DESCRIPTION_SKILLS, data, onSuccess, onError);
  };

  const sendOfferLetterFile = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.OFFER_LETTER.SEND_FILE, data, onSuccess, onError, true);
  };

  const sendOfferLetter = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.OFFER_LETTER.SEND, data, onSuccess, onError, true);
  };

  const generateOfferLetter = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.OFFER_LETTER.GENERATE, data, onSuccess, onError, true);
  };

  const getCountries = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.COUNTRIES_NEW, data, onSuccess, onError);
  };

  const getStates = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.STATES_NEW, data, onSuccess, onError);
  };

  const getCities = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.CITIES_NEW, data, onSuccess, onError);
  };

  const contactSupport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.CONTACT_SUPPORT, data, onSuccess, onError, true);
  };

  return {
    callEnhanceText: enhanceText,
    callGenerateJobDescriptionSkills: generateJobDescriptionSkills,
    callSendOfferLetterFile: sendOfferLetterFile,
    callSendOfferLetter: sendOfferLetter,
    callGenerateOfferLetter: generateOfferLetter,
    callGetCountries: getCountries,
    callGetStates: getStates,
    callGetCities: getCities,
    callContactSupport: contactSupport,
  };
}
